import React, { useEffect, useState } from "react"
import { AnimatePresence, motion } from "framer-motion"

import { GatsbyImage, getImage } from "gatsby-plugin-image"
import "./Galerij.css"

export default function Galerij({ block }) {
  const [currentSlide, setCurrentSlide] = useState(0)
  const [width, setWidth] = useState(0)
  const [slideWidth, setSlideWidth] = useState(0)

  useEffect(() => {
    setWidth(window.innerWidth)
  }, [])

  useEffect(() => {
    if (width > 1024) {
      setSlideWidth(25)
    } else if (width > 768 && width <= 1024) {
      setSlideWidth(50)
    } else {
      setSlideWidth(100)
    }
  }, [width])

  const slides = block.afbeeldingen

  useEffect(() => {
    const interval = setInterval(() => {
      if (width > 1024) {
        if (currentSlide < slides.length - 4) {
          setCurrentSlide(currentSlide + 1)
        } else {
          setCurrentSlide(0)
        }
      } else if (width > 768 && width <= 1024) {
        if (currentSlide < slides.length - 2) {
          setCurrentSlide(currentSlide + 1)
        } else {
          setCurrentSlide(0)
        }
      } else if (width <= 768) {
        if (currentSlide < slides.length - 1) {
          setCurrentSlide(currentSlide + 1)
        } else {
          setCurrentSlide(0)
        }
      }
    }, 5000)

    return () => clearInterval(interval)
  }, [currentSlide])

  console.log(currentSlide * slideWidth)
  // return (
  //   <div>
  //     <div className="vt-galerij-container">
  //       {block.afbeeldingen.map(galerij => {
  //         const image = getImage(
  //           galerij.afbeelding.localFile.childImageSharp.gatsbyImageData
  //         )
  //         return <GatsbyImage className="vt-galerij-afbeelding" image={image} />
  //       })}
  //     </div>
  //   </div>
  // )

  return (
    <motion.div
      className={`hq-hero__slider `}
      initial={{ left: 0 }}
      animate={{ left: `-${currentSlide * slideWidth}vw` }}
      exit={{ left: `-${currentSlide * slideWidth + slideWidth}vw` }}
    >
      {slides.map((s, i) => {
        const image = getImage(
          s.afbeelding.localFile.childImageSharp.gatsbyImageData
        )
        // if (i < currentSlide + 4 && i >= currentSlide) {
        return (
          <div key={i} className="hq-hero__slide--wrapper">
            <div className="hq-hero__slide">
              <GatsbyImage className="vt-galerij-afbeelding" image={image} />
            </div>
          </div>
        )
        // }
      })}
    </motion.div>
  )
}
